/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Breadcrumb/view.blocks to change it.
import AllImageSeries from './AllImageSeries/index'
import ImageSeries from './ImageSeries/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Breadcrumb({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Content/Actions/Upload/Content/Documents/Content/Patients/Content/Breadcrumb"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Breadcrumb.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<AllImageSeries
  viewPath={`${viewPath}/AllImageSeries`}
/>
<ImageSeries
  viewPath={`${viewPath}/ImageSeries`}
/>
</div>
{children}
</React.Fragment>)
}